export default class ExternalRateLimitError extends Error {
  originalErr: Error | null

  name = 'RateLimitedError'

  constructor(message: string, originalErr: Error | null = null) {
    super(message)
    this.originalErr = originalErr
  }
}
